import { render, staticRenderFns } from "./bettinganswer.vue?vue&type=template&id=2db35057&"
import script from "./bettinganswer.vue?vue&type=script&lang=js&"
export * from "./bettinganswer.vue?vue&type=script&lang=js&"
import style0 from "./bettinganswer.vue?vue&type=style&index=0&id=2db35057&prod&lang=css&"
import style1 from "./bettinganswer.vue?vue&type=style&index=1&id=2db35057&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports